// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","697":"news"}[chunkId] || chunkId) + "." + {"177":"b18483f6","464":"c3bbd222","697":"205e7c15","711":"508838d5"}[chunkId] + ".js";
};